// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__w-84P","footer":"ModalInfo_footer__15wfx"};